import Home from '@/views/Home.vue';
import NotFound from '@/views/NotFound.vue';
import { h } from 'vue';
import { RouteRecordRaw, RouterView } from 'vue-router';

const routes = [
  {
    path: '/',
    component: { render: () => h(RouterView) },
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        redirect: '/docs',
      },
      {
        path: '/docs',
        component: Home,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/notFound',
    component: NotFound,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/notFound',
  },
] as RouteRecordRaw[];

export default routes;
